

















































import DictMixin from '@/mixins/dict-mixin';
import { IndicatorDto } from '@/services/indicator';
import { mixins } from 'vue-class-component';
import { Vue, Component, PropSync } from 'vue-property-decorator';
import IndDefinition from './indcator-definition.vue';
import IndCompose from './indcator-compose.vue';
@Component({
  components: { IndDefinition, IndCompose }
})
export default class IndF2 extends mixins(DictMixin) {
  @PropSync('formData') syncFormData!: IndicatorDto;

  get typeList() {
    let obj: any = [[], [], [], []];
    this.DICT_MEASURE_UNIT?.forEach((dict: any, k: number) => {
      if (k < 7) obj[0].push(dict);
      if (k >= 7 && k <= 14) obj[1].push(dict);
      if (k >= 15 && k <= 19) obj[2].push(dict);
      if (k > 19) obj[3].push(dict);
    });
    return obj;
  }
}
